import React, { useState } from "react";
import { FaFacebook, FaInstagram, FaLinkedin, FaLinkedinIn, FaTiktok, FaYoutube } from 'react-icons/fa';
import SwoodleLogo from "../../Assets/Icons/SwoodleUpdatedLogo.svg";
import BlueRing from "../../Assets/Icons/bluering.svg";
import Flower from "../../Assets/Icons/flower.svg";
import ZigZag from "../../Assets/Icons/zigzagline.svg";
const DEFAULT_LINKS = {
  home: "https://swoodle.com.au/",
  contact: "https://swoodle.com.au/contact-us/",
  privacy: "https://swoodle.com.au/privacy-policy/",
  terms: "https://swoodle.com.au/terms-and-conditions/",
  merchantBenefits: "https://swoodle.com.au/members/",
  fundraiser: "https://swoodle.com.au/fundraiser/",
  membersBenefits: "https://swoodle.com.au/members-benefits/",
  joinNow: "https://panel.swoodle.com.au/member-setup",
  socials: {
    instagram: "https://www.instagram.com/swoodleau/",
    facebook: "https://www.facebook.com/swoodleau/",
    youtube: "https://www.youtube.com/@swoodleau",
    linkedin: "https://www.linkedin.com/company/swoodleau/",
    tiktok: "https://www.tiktok.com/@swoodle_",
  },
};
const NEWSLETTER_ENDPOINT = process.env.REACT_APP_NEWSLETTER_SUBSCRIBE_URL || "";

const SwoodleMobileFooter = ({ links = DEFAULT_LINKS }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const isValidEmail = (val) => /[^\s@]+@[^\s@]+\.[^\s@]+/.test(val);

  const onSubmitNewsletter = async (e) => {
    e?.preventDefault?.();
    setMessage("");
    if (!isValidEmail(email)) {
      setMessage("Please enter a valid email.");
      return;
    }
    if (NEWSLETTER_ENDPOINT) {
      try {
        setLoading(true);
        const resp = await fetch(NEWSLETTER_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });
        const data = await resp.json().catch(() => ({}));
        if (!resp.ok) throw new Error(data?.message || "Subscription failed");
        setMessage("Thanks! You are subscribed.");
        setEmail("");
      } catch (err) {
        setMessage(err?.message || "Subscription failed. Please try again later.");
      } finally {
        setLoading(false);
      }
    } else {
      window.location.href = `mailto:info@swoodle.com.au?subject=Subscribe%20to%20Newsletter&body=Please%20subscribe%20${encodeURIComponent(
        email
      )}%20to%20the%20newsletter.`;
    }
  };

  const A = ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="hover:underline">
      {children}
    </a>
  );

  return (
    <footer className="w-full bg-[#242856] text-white mt-10 rounded-[32px] relative overflow-hidden">
            <img src={ZigZag} alt="" className="hidden md:block pointer-events-none absolute left-[-40px] top-[64px] w-[260px] z-20" />
      <img src={BlueRing} alt="" className="hidden md:block absolute right-[300px] bottom-[122px] w-[26px] z-20" />
      <img src={BlueRing} alt="" className="hidden md:block absolute right-[268px] bottom-[122px] w-[26px] z-20" />
      <img src={BlueRing} alt="" className="hidden md:block absolute right-[236px] bottom-[122px] w-[26px] z-20" />
      <img src={Flower} alt="" className="hidden md:block absolute right-[172px] bottom-[100px] w-[44px] z-20" />

      <div className="px-6 py-14 md:py-20 max-w-[1450px] mx-auto relative">
        <div className="rounded-[24px] bg-[#242856] border border-[#31356B] p-6 md:p-12 mb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
            <h3 className="text-[26px] md:text-[40px] leading-tight font-[400]">
              Stay Updated With <br />
              <span className="text-[#13A0E1]">Swoodle News</span>
            </h3>

            <div>
              <p className="text-[#C4C4C4] text-[14px] mb-3">
                Sign up to receive the latest updates and offers.
              </p>

              <form onSubmit={onSubmitNewsletter} className="flex flex-col sm:flex-row gap-3 w-full">
                   <input
            type="email"
            value={email}
            placeholder="Enter Your Email"
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 h-[48px] rounded-[12px] px-4 py-3 bg-transparent border border-[#D6B05F] text-white outline-none"
          />
                <button
                  type="submit"
                  disabled={loading}
                  className="h-[48px] rounded-[22px] bg-[#F1BE3B] text-[#FFFFFF] font-[700] px-6 sm:min-w-[200px] hover:opacity-90 disabled:opacity-70"
                >
                  {loading ? "Submitting..." : "Join Newsletter"}
                </button>
              </form>

              {message && (
                <div className="text-[12px] mt-2 text-[#C4C4C4]">{message}</div>
              )}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 md:gap-12">
          
          <div>
            <img src={SwoodleLogo} alt="Swoodle" className="w-[150px] h-auto" />
            <p className="text-[#C4C4C4] text-[14px] mt-4">
              Promote your business. Reach new customers and build loyalty.
            </p>
            {/* <div className="flex items-center gap-4 mt-4">
              <A href={links.socials.instagram}><FaTiktok size={20} color="#FFC943" /></A>
              <A href={links.socials.facebook}><FaLinkedin size={20} color="#FFC943" /></A>
              <A href={links.socials.youtube}><FaTiktok size={20} color="#FFC943" /></A>
              <A href={links.socials.linkedin}><FaLinkedin size={20} color="#FFC943" /></A>
              <A href={links.socials.tiktok}><FaTiktok size={20} color="#FFC943" /></A>
            </div> */}
{/* <div className="flex items-center gap-4 mt-4">
  <A href={links.socials.instagram}><FaInstagram size={24} color="#F1BE3B" /></A>
  <A href={links.socials.facebook}><FaFacebook size={24} color="#F1BE3B" /></A>
  <A href={links.socials.youtube}><FaYoutube size={24} color="#F1BE3B" /></A>
  <A href={links.socials.linkedin}><FaLinkedinIn size={24} color="#F1BE3B" /></A>
  <A href={links.socials.tiktok}><FaTiktok size={24} color="#F1BE3B" /></A>
</div> */}

<div className="flex items-center gap-4 mt-4">
  <A href={links.socials.instagram}><FaInstagram className="w-[22px] h-[22px]" color="#F1BE3B" /></A>
  <A href={links.socials.facebook}><FaFacebook className="w-[22px] h-[22px]" color="#F1BE3B" /></A>
  <A href={links.socials.youtube}><FaYoutube className="w-[22px] h-[22px]" color="#F1BE3B" /></A>
  <A href={links.socials.linkedin}><FaLinkedin className="w-[22px] h-[22px]" color="#F1BE3B" /></A>
  <A href={links.socials.tiktok}><FaTiktok className="w-[22px] h-[22px]" color="#F1BE3B" /></A>
</div>


          </div>

          <div>
            <h4 className="font-[700] mb-3">QUICK LINKS</h4>
            <ul className="space-y-2 text-[#C4C4C4] text-[14px]">
              <li><A href={links.home}>Home</A></li>
              <li><A href={links.contact}>Contact Us</A></li>
              <li><A href={links.privacy}>Privacy Policy</A></li>
              <li><A href={links.terms}>T&C's</A></li>
            </ul>
          </div>

          <div>
            <h4 className="font-[700] mb-3">RESOURCES</h4>
            <ul className="space-y-2 text-[#C4C4C4] text-[14px]">
              <li><A href={links.membersBenefits}>Memberships</A></li>
              <li><A href={links.merchantBenefits}>Merchant Benefits</A></li>
              <li><A href={links.fundraiser}>Fundraisers</A></li>
              <li><A href={links.joinNow}>Join Now</A></li>
            </ul>
          </div>

          <div>
            <h4 className="font-[700] mb-3">GET IN TOUCH</h4>
            <ul className="space-y-2 text-[#C4C4C4] text-[14px]">
              <li>105a Glenferrie Rd Malvern, VIC 3144</li>
              <li><a href="tel:+61401811115" className="hover:underline">0401 811 115</a></li>
              <li><a href="mailto:info@swoodle.com.au" className="hover:underline">info@swoodle.com.au</a></li>
            </ul>
          </div>

        </div>

        <div className="text-center text-[#C4C4C4] text-[12px] mt-12">
          © {new Date().getFullYear()} Swoodle. All rights reserved.
        </div>

      </div>
    </footer>
  );
};

export default SwoodleMobileFooter;
